import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { memo } from 'react';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import { Tag } from './styles';

const NavbarDropdownLinks = ({ link, dropdownCategory, ...other }) => {
  const { heading, links, linksWithPhotos, linksWithIcons } = link;
  const headingLinkObj = heading ? buildLinkObj(heading) : null;
  return (
    <Box mb={4} pr={4} sx={{ minWidth: '180px' }} {...other}>
      {heading?.link || heading?.externalLink ? (
        <Typography
          component="a"
          href={headingLinkObj?.href}
          rel={getRel(headingLinkObj)}
          variant="h6"
          align="left"
          px={2}
          className="tra-text-web-sub-2 hover:tw-text-brand-400"
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {heading?.displayName}
          <ChevronRightIcon alt="" role="presentation" />
        </Typography>
      ) : (
        <Typography variant="h5" align="left" px={2} className="tra-text-web-sub-2">
          {heading?.displayName}
        </Typography>
      )}
      <List>
        {links &&
          links.map((dropdownLink, index) => {
            const linkObj = buildLinkObj(dropdownLink);
            return (
              <ListItem
                key={`${linkObj.text}_${index}`}
                onClick={() =>
                  navigationClicked({
                    nav_type: 'Top Navigation',
                    clicked_text: linkObj?.text ?? '',
                    primary_header: dropdownCategory?.props?.dropdownName ?? '',
                    secondary_header: heading?.displayName ?? '',
                  })
                }
              >
                <a href={linkObj.href} rel={getRel(linkObj)} className="hover:tw-text-brand-400">
                  {linkObj.text}
                  {dropdownLink.tag && <Tag>{dropdownLink.tag}</Tag>}
                </a>
              </ListItem>
            );
          })}
        {linksWithIcons &&
          linksWithIcons.map((dropdownLinkWithIcon, index) => {
            const imgUrl =
              dropdownLinkWithIcon.imageContent?.image || dropdownLinkWithIcon.image
                ? buildImageSrc(
                    dropdownLinkWithIcon.imageContent?.image
                      ? dropdownLinkWithIcon.imageContent
                      : dropdownLinkWithIcon.image,
                    27,
                    1,
                    1,
                  )
                : null;
            const linkObj = buildLinkObj(dropdownLinkWithIcon);
            return (
              <ListItem key={`${linkObj.text}_${index}`}>
                <a href={linkObj.href} rel={getRel(linkObj)}>
                  {imgUrl && (
                    <img src={imgUrl} alt="" role="presentation" width="27px" className="tw-mr-4" />
                  )}
                  {linkObj.text}
                </a>
              </ListItem>
            );
          })}
        {linksWithPhotos &&
          linksWithPhotos.map((dropdownLinkWithPhoto, index) => {
            const imgUrl = dropdownLinkWithPhoto.image
              ? buildImageSrc(dropdownLinkWithPhoto.image, 70, 7, 5)
              : null;
            const linkObj = buildLinkObj(dropdownLinkWithPhoto);
            return (
              <ListItem key={`${linkObj.text}_${index}`}>
                <a href={linkObj.href} rel={getRel(linkObj)}>
                  {imgUrl && (
                    <img src={imgUrl} alt="" role="presentation" className="tw-mr-4 tw-rounded" />
                  )}
                  {linkObj.text}
                </a>
              </ListItem>
            );
          })}
      </List>
    </Box>
  );
};

export default memo(NavbarDropdownLinks);
